import { motion } from "framer-motion";
import { SectionHead, EASE } from "./SectionHead";

export const Skills = ({ index, site }) => (
  <section id="skills" data-testid="skills-section" className="relative px-5 sm:px-10 lg:px-16 py-16 md:py-24 border-t border-[#F5A524]/15">
    <SectionHead index={index} kicker="SKILLS" title={<>Tool<span className="text-[#F5A524]">kit</span></>} />
    <ul className="border-t border-[#F5A524]/20 lg:border-t-0 lg:grid lg:grid-cols-2 lg:gap-x-12">
      {(site?.skills ?? []).map((s, i) => (
        <motion.li key={s.name} data-testid={`skill-row-${i}`} initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.8, delay: i * 0.07, ease: EASE }}
          className="group relative border-b border-[#F5A524]/20 overflow-hidden lg:[&:nth-child(-n+2)]:border-t">
          <span className="absolute inset-0 bg-[#F5A524] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out" />
          <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-2 md:gap-4 lg:gap-3 py-4 md:py-7 lg:py-6 px-2">
            <div className="flex items-baseline gap-4 md:gap-6">
              <span className="font-mono text-xs text-[#F5A524] group-hover:text-black transition-colors">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-display font-black uppercase text-2xl sm:text-5xl lg:text-4xl text-white group-hover:text-black transition-colors group-hover:translate-x-3 duration-500 inline-block">{s.name}</span>
            </div>
            <div className="flex flex-wrap gap-1.5 md:gap-2 pl-8 md:pl-0">
              {(s.tools ?? []).map((t) => (
                <span key={t} className="font-mono text-[11px] tracking-[0.15em] md:tracking-[0.2em] uppercase border border-[#F5A524]/30 group-hover:border-black text-zinc-300 group-hover:text-black px-2 py-1 md:px-3 md:py-1.5 transition-colors">{t}</span>
              ))}
            </div>
          </div>
        </motion.li>
      ))}
    </ul>
  </section>
);
